import { Stack } from 'components/Stack'
import { styled } from 'stitches.config'

export const PostRoot = styled('div', {
  position: 'relative',
  color: '$accent-black',
  backgroundColor: '$tertiary-200',
})

export const Hero = styled('div', {
  position: 'relative',
  zIndex: 1,
})

export const ImageWrapper = styled('div', {
  maxWidth: '$max',
  px: '$3',

  '@bp3': {
    px: '$8',
  },

  img: {
    width: '100%',
    borderRadius: '22px',
  },
})

export const BlogHeroBlob = styled('div', {
  display: 'none',

  '@bp2': {
    position: 'absolute',
    right: 0,
    top: '50%',
    maskImage: 'url(/assets/blog-hero-blob.svg)',
    webkitMaskImage: 'url(/assets/blog-hero-blob.svg)',
    backgroundColor: '$primary-500',
    width: '180px',
    height: '220px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transform: 'translate(15%, -50%)',
    maskSize: 'contain',
    WebkitMaskSize: 'contain',
    WebkitMaskRepeat: 'no-repeat',
  },

  '@bp3': {
    width: '204px',
    height: '245px',
  },
})

export const BlogPatternHero = styled('div', {
  position: 'absolute',
  left: 0,
  right: 0,
  top: '50%',
  zIndex: -1,
  transform: 'translate(-35%, -50%)',
  maxWidth: '300px',

  '@bp1': {
    maxWidth: '350px',
  },

  '@bp2': {
    maxWidth: '600px',
  },

  '@bp3': {
    transform: 'translate(-30%, -45%)',
    maxWidth: '750px',
  },
})

export const ContentCard = styled('div', {
  px: '$3',

  '@bp2': {
    px: '$15',
  },
})

export const Wrapper = styled('div', {
  maxWidth: '$max',
  margin: 'auto',
  marginBottom: '$13',
})

export const TitleWrapper = styled('div', {})

export const Background = styled('div', {
  position: 'relative',
  top: '-$13',
  marginBottom: '-$13',
  zIndex: 0,
  borderTopLeftRadius: '75px',
  borderTopRightRadius: '75px',
  paddingTop: '112px',

  '@bp2': {
    paddingTop: '120px',
  },
})

export const Tag = styled('div', {
  px: '$4',
  py: '4px',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '$primary-500',
  color: '$primary-500',
  backgroundColor: 'transparent',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '22px',
})

export const SocialMediaShareContainer = styled(Stack, {
  alignSelf: 'flex-end',
  px: '$3',

  '@bp3': {
    px: '$8',
  },
})
